import { useCallback, useEffect, useState } from 'react';

import { logger } from '@/utils/logger';

export const useOnlineStatus = (): boolean => {
  const [isOnline, setIsOnline] = useState(() =>
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );

  const handleOnline = useCallback(() => {
    logger.info('[OnlineStatus] Connection restored');
    setIsOnline(true);
  }, []);

  const handleOffline = useCallback(() => {
    logger.warn('[OnlineStatus] Connection lost');
    setIsOnline(false);
  }, []);

  useEffect(() => {
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        setIsOnline(navigator.onLine);
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [handleOnline, handleOffline]);

  return isOnline;
};

export default useOnlineStatus;
